"use client";

import type { FFmpeg } from "@ffmpeg/ffmpeg";

let ffmpegPromise: Promise<FFmpeg> | null = null;

/**
 * ffmpeg.wasm'ı tarayıcıda tembel yükler. Çekirdek dosyaları yereldedir
 * (public/ffmpeg/), dışarı bağımlılık yoktur. Tek çekirdekli (single-thread)
 * sürüm kullanılır; böylece COOP/COEP izolasyonu gerekmez ve AdSense çalışır.
 * ~31 MB çekirdek yalnızca ilk video işleminde bir kez iner.
 */
export async function getFfmpeg(): Promise<FFmpeg> {
  if (!ffmpegPromise) {
    ffmpegPromise = (async () => {
      const [{ FFmpeg }, { toBlobURL }] = await Promise.all([
        import("@ffmpeg/ffmpeg"),
        import("@ffmpeg/util"),
      ]);
      const ff = new FFmpeg();
      await ff.load({
        coreURL: await toBlobURL("/ffmpeg/ffmpeg-core.js", "text/javascript"),
        wasmURL: await toBlobURL("/ffmpeg/ffmpeg-core.wasm", "application/wasm"),
      });
      return ff;
    })();
  }
  return ffmpegPromise;
}

/** Dosya adından güvenli bir kök ad üretir (uzantısız). */
export function kokAd(ad: string) {
  return ad.replace(/\.[^.]+$/, "").replace(/[^\w.-]+/g, "_") || "video";
}
